import React from 'react';

export const Input = props => {
    return (
        <div className={`formInput ${props.extraClasses}`}>
            <label> {props.label} </label>
            <input type={props.type} onChange={props.handler} onBlur={props.blured} placeholder={props.placeholder} value={props.value}/>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Inputs.js